import { useMemo } from 'react'

import { Can, routes } from '@builddocs/data-management'
import { List, Stack } from '@mui/material'
import { useLocation } from 'react-router-dom'

import BusinessIcon from '../../assets/business.svg'
import ProjectsIcon from '../../assets/projects.svg'

import NavigationButton from './atoms/NavigationButton'

export const Navigation = () => {
  const location = useLocation()
  const currentTab = useMemo(() => {
    if (location.pathname.startsWith(routes.navigator.base())) return 'projects'
    else if (location.pathname.startsWith(routes.projects.base()))
      return 'projects'
    else if (location.pathname.startsWith(routes.organization.base()))
      return 'organization'
    else return undefined
  }, [location.pathname])

  return (
    <Stack
      component="nav"
      direction="row"
      justifyContent="flex-start"
      spacing={{ xs: 0, sm: 1, md: 0, lg: 1 }}
    >
      <List sx={{ display: 'flex', '& *': { color: 'text.primary' } }}>
        <NavigationButton
          icon={ProjectsIcon}
          label="Проекты"
          selected={currentTab === 'projects'}
          to={routes.navigator.base()}
        />
        <Can passThrough I="edit" a="Organization">
          {(can: boolean) =>
            can && (
              <NavigationButton
                icon={BusinessIcon}
                label="Управление организацией"
                selected={currentTab === 'organization'}
                to={routes.organization.base()}
              />
            )
          }
        </Can>
      </List>
    </Stack>
  )
}

export default Navigation
